"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var pp_react_radio_1 = require("@paypalcorp/pp-react-radio");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var addressErrors_1 = require("../../../utils/errorcodes/addressErrors");
var constants_1 = require("../../../constants");
var ROUTES = constants_1.default.ROUTES, VIEWS = constants_1.default.VIEWS, FPTI = constants_1.default.FPTI;
var commonUtils_1 = require("../../../common/utils/commonUtils");
var commonweb_utils_1 = require("commonweb-utils");
var addresses_1 = require("../../../actions/addresses");
var interpolate_component_1 = require("../../../components/interpolate-component");
var triggerOperationResult_1 = require("../../../utils/fpti/triggerOperationResult");
var addressDisplay_1 = require("./addressDisplay");
var icons_component_1 = require("../../../components/icons.component");
var beaver_logger_1 = require("../../../utils/logging/beaver-logger");
var constants_2 = require("./constants");
var page = require("page");
/**
 * Remove address component
 * @author pkatoria
 */
var RemoveAddress = /** @class */ (function (_super) {
    tslib_1.__extends(RemoveAddress, _super);
    function RemoveAddress(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickRadio = function (event) {
            if (event.target && event.target.value) {
                var selectedAddress = JSON.parse(event.target.value);
                var updatedForm = tslib_1.__assign({}, _this.state.form);
                updatedForm.newPrimaryAddress = selectedAddress;
                _this.setState({ form: updatedForm });
            }
        };
        _this.getErrorComponent = function (errorCode, errorContent) {
            var addressContent = _this.props.addressContent, commonContent = _this.props.commonContent, walletUrl = _this.props.links.wallet.linkUrl, customerCareUrl = _this.props.links.help.linkUrl, finalErrorContent, walletLinkComponent, customerCareLinkComponent, errorComponent;
            if (errorCode ===
                addressErrors_1.errorCodes.WALLET_SETTING_ADDRESS_CANNOT_REMOVE_BILLING) {
                finalErrorContent = addressContent.error.errorAddressRemoveBilling;
                var deviceType = commonweb_utils_1.objectUtils.safeGet(_this.props.deviceInfo, "deviceType");
                if (deviceType === "WEBVIEW") {
                    walletLinkComponent = addressContent.walletLink;
                }
                else {
                    walletLinkComponent = (React.createElement(pp_react_1.Link, { key: addressContent.walletLink, href: walletUrl }, addressContent.walletLink));
                }
                errorComponent = interpolate_component_1.InterpolateLinksWithComponent(finalErrorContent, [
                    walletLinkComponent,
                ]);
            }
            else if (errorCode === addressErrors_1.errorCodes.WALLET_SETTING_ADDRESS_INVALID_ID) {
                finalErrorContent = commonContent.error.errorGeneric;
                customerCareLinkComponent = (React.createElement(pp_react_1.Link, { key: commonContent.customerCareLink, href: customerCareUrl }, commonContent.customerCareLink));
                errorComponent = interpolate_component_1.InterpolateLinksWithComponent(finalErrorContent, [
                    customerCareLinkComponent,
                ]);
            }
            else {
                finalErrorContent = errorContent;
                errorComponent = interpolate_component_1.InterpolateLinksWithComponent(finalErrorContent, [
                    customerCareLinkComponent,
                ]);
            }
            return errorComponent;
        };
        _this.getButton = function () {
            return (React.createElement(pp_react_1.Button, { className: "fullWidth test_removeButton", name: _this.props.addressFpti.submitRemove, type: "submit", disabled: _this.state.showSpinner }, _this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "loading-spinner", screenReaderText: "loading", inverse: true })) : (_this.props.commonContent.remove)));
        };
        _this.submitHandler = function (event) {
            event.preventDefault();
            if (_this.state.addressToRemove.cardList) {
                var errorComponent = _this.getErrorComponent("errorAddressRemoveBilling", null);
                _this.setState({
                    errorMessage: errorComponent,
                }, function () {
                    _this.setErrorMessageInView();
                });
                return;
            }
            if (_this.state.addressToRemove.primary &&
                _this.state.form.newPrimaryAddress === null) {
                _this.setState({
                    errorMessage: _this.props.addressContent.removePrimary
                        .infoAlert,
                }, function () {
                    _this.setErrorMessageInView();
                });
                return;
            }
            if (_this.state.formIsValid) {
                _this.setState({ showSpinner: true });
                var formData = {};
                for (var formElementIdentifier in _this.state.form) {
                    formData[formElementIdentifier] = _this.state.form[formElementIdentifier];
                }
                var toastIntent_1 = _this.state.addressToRemove && _this.state.addressToRemove.primary
                    ? VIEWS.ADDRESSES.TOAST_INTENTS.REMOVE_PRIMARY
                    : VIEWS.ADDRESSES.TOAST_INTENTS.REMOVE;
                ajax_util_1.default.delete$(_this.props.dispatch, _this.props._csrf, "" + ROUTES.API.ADDRESSES.REMOVE, formData, { component: { name: VIEWS.ADDRESSES.DELETE } })
                    .then(function (newAddress) {
                    var returnUrl = null, fptiValue = null;
                    var isFlow = _this.props.route.isFlow || false, flowName = _this.props.route.enter.flow || "", isBaseFlowInHistory = commonUtils_1.isBaseFlowPresent(_this.props, ROUTES);
                    var removeAddressId = _this.props.route.enter.params.id, addressData = _this.props.addressData, addressAll = addressData.addresses, filteredAddresses = addressAll.filter(function (address) { return address.id !== removeAddressId; });
                    if (_this.state.addressToRemove.primary && newAddress.id) {
                        var newPrimaryAddressIndex = filteredAddresses.findIndex(function (address) { return address.id === newAddress.id; });
                        if (newPrimaryAddressIndex >= 0) {
                            filteredAddresses[newPrimaryAddressIndex] = newAddress;
                        }
                    }
                    addressData.addresses = filteredAddresses;
                    _this.props.dispatchRemoveAddress(addressData);
                    returnUrl = constants_1.default.BASE_URI + "/flow-return/" + flowName + "?success=removeAddress";
                    fptiValue = _this.props.addressFpti.remove;
                    if (toastIntent_1 ===
                        VIEWS.ADDRESSES.TOAST_INTENTS.REMOVE_PRIMARY) {
                        if (window &&
                            window.venice &&
                            typeof window.venice.primaryAddressModified ===
                                "function") {
                            window.venice.primaryAddressModified();
                        }
                        fptiValue = _this.props.addressFpti.removePrimary;
                        returnUrl = constants_1.default.BASE_URI + "/flow-return/" + flowName + "?success=removePrimaryAddress";
                    }
                    _this.props.removeAction(toastIntent_1);
                    if (isFlow && !isBaseFlowInHistory) {
                        triggerOperationResult_1.triggerOperationResult(fptiValue, FPTI.SUCCESS, null);
                        page(returnUrl);
                    }
                    else {
                        page.back();
                    }
                })
                    .catch(function (error) {
                    _this.setState({ showSpinner: false });
                    var errorStatusCode = commonweb_utils_1.objectUtils.safeGet(error, "statusCode") || 500;
                    var errorDescFPTI;
                    beaver_logger_1.default().info(constants_2.ADDRESS.REMOVE_ADDRESS, {
                        errorCode: errorStatusCode,
                        message: error && error.message,
                    });
                    if (errorStatusCode >= 400 && errorStatusCode < 500) {
                        var code = addressErrors_1.errorCodes[error.errorKey];
                        var errorContent = _this.props.addressContent.error[code];
                        if (code) {
                            if (code ===
                                addressErrors_1.errorCodes.WALLET_SETTING_ADDRESS_CANNOT_REMOVE_BILLING ||
                                addressErrors_1.errorCodes.WALLET_SETTING_ADDRESS_INVALID_ID) {
                                errorContent = _this.getErrorComponent(code, null);
                            }
                            else {
                                errorContent = _this.getErrorComponent(null, errorContent);
                            }
                        }
                        _this.setState({ errorMessage: errorContent });
                        errorDescFPTI = errorContent;
                    }
                    else {
                        var genericError = _this.getErrorComponent("errorGeneric", null);
                        _this.setState({ errorMessage: genericError });
                        errorDescFPTI = genericError;
                    }
                    triggerOperationResult_1.triggerOperationResult(_this.props.addressFpti.remove, "fail", errorDescFPTI);
                    return;
                });
            }
        };
        var removeAddressId = _this.props.route.enter.params.id, addressAll = _this.props.addressData.addresses, addressToRemove = addressAll.find(function (addr) { return addr.id === removeAddressId; });
        _this.state = {
            form: {
                id: commonweb_utils_1.objectUtils.safeGet(props, "route.enter.params.id") || "",
                newPrimaryAddress: null,
            },
            formIsValid: true,
            errorMessage: "",
            showSpinner: false,
            addressToRemove: addressToRemove,
        };
        return _this;
    }
    RemoveAddress.prototype.componentDidMount = function () {
        window.scroll({ top: 0, behavior: "smooth" });
    };
    RemoveAddress.prototype.setErrorMessageInView = function () {
        window.scroll({ top: 0, behavior: "smooth" });
    };
    RemoveAddress.prototype.render = function () {
        var _this = this;
        var addressAll = this.props.addressData.addresses, removeAddressId = this.props.route.enter.params.id, nonPrimaryform, primaryForm;
        var addressFpti = this.props.addressFpti, filteredAddresses = addressAll.filter(function (address) { return address.id !== removeAddressId; }), nonPrimaryAddresses = filteredAddresses.map(function (address, key) {
            var addressString = (React.createElement(addressDisplay_1.default, { displayMetadata: address.displayMetadata }));
            return {
                label: addressString,
                value: JSON.stringify(address),
            };
        });
        nonPrimaryform = (React.createElement("form", { className: "fullHeight", onSubmit: this.submitHandler },
            this.state.errorMessage ? (React.createElement(pp_react_1.Alert, { className: "dividerMargin", type: "error" }, this.state.errorMessage)) : null,
            React.createElement("div", { className: this.state.errorMessage ||
                    (this.state.addressToRemove &&
                        this.state.addressToRemove.cardList)
                    ? "formContent_center updatePageError_height lineItems_secondary"
                    : "formContent_center fullHeight lineItems_secondary" },
                React.createElement("div", null,
                    React.createElement(icons_component_1.IllustrationComponent, { modifierClass: "updateWarning-icon", image: "Warning" }),
                    React.createElement("div", { className: "updateWarning-content" },
                        " ",
                        React.createElement(pp_react_1.Text, { size: "xl3" }, this.props.addressContent.removeAddress
                            .warning)),
                    React.createElement("div", { className: "componentBody-content" },
                        React.createElement(addressDisplay_1.default, { displayMetadata: this.state.addressToRemove.displayMetadata })))),
            React.createElement("div", { className: this.state.errorMessage ||
                    this.state.addressToRemove.cardList
                    ? "formButton_bottom updateErrorButton_height"
                    : "formButton_bottom updateButton_height" }, this.getButton())));
        primaryForm = (React.createElement("form", { onSubmit: this.submitHandler },
            this.state.errorMessage ? (React.createElement(pp_react_1.Alert, { className: "dividerMargin", type: "error" }, this.state.errorMessage)) : null,
            React.createElement("div", null,
                React.createElement("div", { className: "removePrimary-header" },
                    " ",
                    React.createElement(pp_react_1.Text, { size: "xl3" }, this.props.addressContent.removePrimary.warning)),
                React.createElement(pp_react_1.Divider, { secondary: true }),
                React.createElement(pp_react_radio_1.RadioButton, { className: this.state.showSpinner ? "clickDisabled" : null, name: "addressListRadio", value: "", onClick: function (event) { return _this.onClickRadio(event); }, options: nonPrimaryAddresses })),
            React.createElement("div", null,
                React.createElement(pp_react_1.Button, { className: "addUpdateButton_space fullWidth test_removeButton", name: addressFpti.submitRemovePrimary, type: "submit", disabled: this.state.showSpinner }, this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "loading-spinner", screenReaderText: "loading", inverse: true })) : (this.props.commonContent.save)))));
        return (React.createElement("div", { className: "fullHeight" }, this.state.addressToRemove.primary &&
            !this.state.addressToRemove.cardList
            ? primaryForm
            : nonPrimaryform));
    };
    return RemoveAddress;
}(React.Component));
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, links = _a.links, fpti = _a.fpti, deviceInfo = _a.deviceInfo;
    var addressData = account.addressData, addressFpti = fpti.address, addressContent = content.addresses, commonContent = content.common;
    return {
        _csrf: _csrf,
        ui: ui,
        addressContent: addressContent,
        commonContent: commonContent,
        route: route,
        addressData: addressData,
        links: links,
        addressFpti: addressFpti,
        deviceInfo: deviceInfo,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchRemoveAddress: function (addressInfo) {
            return dispatch(addresses_1.removeAddress(addressInfo));
        },
        removeAction: function (typeOfAction) { return dispatch(addresses_1.actionType(typeOfAction)); },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(RemoveAddress);
